export default __webpack_public_path__ + "static/assembly-363d0bf235a235c8fc3203dc1ce02e8b.jpg";